// extracted by extract-css-chunks-webpack-plugin
module.exports = {"heading":"Heading__heading","heading__qanelas":"Heading__heading__qanelas","heading__norms":"Heading__heading__norms"};